import { useGamificationBalance } from "../lib/GamificationBalanceProvider";
import { useSchool } from "../lib/hooks";

import { Image } from "./Image";

type Props = {
  /** Stack icon above balance/name instead of rendering in a row. */
  vertical?: boolean;
  iconSize?: number;
};

export const GamificationBalance: React.FC<Props> = ({ vertical = false, iconSize = 30 }) => {
  const gamificationBalance = useGamificationBalance();
  const school = useSchool();

  const gamification = school.gamification;
  if (!gamification) return null;

  return (
    <div className={`flex gap-5 align-center${vertical ? " flex-col" : ""}`}>
      <Image
        fit="fill"
        cloudKey={gamification.pointsIconCloudKey}
        width={iconSize}
        height={iconSize}
        resize={{ h: iconSize, w: iconSize }}
      />
      {gamificationBalance}
      <span>{gamification.pointsShortName}</span>
    </div>
  );
};
